<template>
  <section>
    <div class="my-4">
      <div class="row">
        <div class="col-12">
          <h3>{{ $t('message.professional.filters') }}</h3>
          <hr>
        </div>
        <div class="col-12">
          <!-- Excellent Provider -->
          <div class="custom-control custom-checkbox">
            <input id="excellent_provider"
                   type="checkbox"
                   name="excellent_provider"
                   class="custom-control-input"
                   :true-value="1"
                   :false-value="0"
                   v-model="queryData.is_excellent"
                   @change="loadByFilter()">
            <label for="excellent_provider" class="mb-0 custom-control-label">
              <img src="/static/img/ic_badge_excellent.png" alt="" width="24"> {{ $t('message.professional.excellent_providers') }}
            </label>
          </div>
        </div>
        <div class="col-12">
          <!-- Vaccinated professional -->
          <div class="mt-3 custom-control custom-checkbox">
            <input id="vaccinated_professional"
                   type="checkbox"
                   name="vaccinated_professional"
                   class="custom-control-input"
                   :true-value="1"
                   :false-value="0"
                   v-model="queryData.vaccinated_professional"
                   @change="loadByFilter()">
            <label for="vaccinated_professional" class="mb-0 custom-control-label">
              <img src="/static/img/covid-vaccinated.png" alt="" width="24"> {{ $t('message.professional.vaccinated_professional') }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-2" v-if="recommendProfessionals">
      <div class="row">
        <div class="col-lg-3 col-6 pb-3 col-recommend-professional px-2"
             v-for="professional in recommendProfessionals">
          <recommend-professional :professional="professional"/>
        </div>
      </div>
      <div class="mb-5 mt-5">
        <mugen-scroll :handler="loadMore" :should-handle="!loading">
          <template v-if="state.isMore">
            <div class="text-center">
              <img src="/static/img/loader.gif" width="80">
            </div>
          </template>
        </mugen-scroll>
      </div>
    </div>
    <div v-else>
      <loader/>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import loader from '../loader/Loader'
  import recommendProfessional from '../recommend/components/RecommendProfessional'
  import MugenScroll from 'vue-mugen-scroll'
  import insiderHelpers from '../../helpers/insiderHelpers'

  export default {
    components: {
      loader,
      recommendProfessional,
      MugenScroll
    },
    data () {
      return {
        queryData: {
          page: 0,
          limit: 8,
          province_id: this.$route.params.id,
          is_excellent: 0,
          vaccinated_professional: 0
        },
        loading: false
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        isLoadMore: 'professional/isLoadMore',
        isMore: 'professional/getIsMore',
        recommendProfessionals: 'professional/getRecommendProfessionals',
        state: 'professional/getState',
        user: 'auth/getUser'
      })
    },
    watch: {
      recommendProfessionals () {
        if (this.recommendProfessionals.length > 0) {
          this.loading = false
        }
      }
    },
    methods: {
      loadByFilter () {
        this.queryData.page = 0
        this.$store.commit('professional/SET_RECOMMEND_PROFESSIONAL_LIST', [])
        this.$store.dispatch('professional/LOAD_RECOMMEND_PROFESSIONAL_LIST', this.queryData)
      },
      loadFirstPage () {
        this.queryData.page = 0
        this.$store.dispatch('professional/LOAD_RECOMMEND_PROFESSIONAL_LIST', this.queryData)
      },
      loadMore () {
        this.loading = true
        setTimeout(() => {
          this.queryData.page++
          this.$store.dispatch('professional/LOAD_RECOMMEND_PROFESSIONAL_LIST', this.queryData)
        }, 2500)
      }
    },
    mounted () {
      this.$store.commit('professional/SET_RECOMMEND_PROFESSIONAL_LIST', [])
      this.loadFirstPage()
      // Insider category page view event
      insiderHelpers.categoryPageViewEvent(this.user, ['Service Providers', 'Recommended Service Providers'])
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/recommend/Index.vue